import { useContext } from 'react';
import { CoinBalanceContext } from '@/context/coin-balance-context';

export function useCoinBalance() {
  const context = useContext(CoinBalanceContext);
  if (!context) {
    throw new Error('useCoinBalance must be used within a CoinBalanceProvider');
  }
  return context;
}
